<!--Этот компонент применяется на детальной товара и в каталоге товаров-->
<template>
<!--  product-detail__page добавляем для страницы детальной товара  -->
    <div class="product-detail" :class="{'product-detail__page': !popupMode}">
        <div class="product-detail-top">
            <div>
                <product-slider :result="product.morePhotos" />
                <div class="social-block">
                    <a v-for="(item, key) in obData.socLinksShared"
                       :href="item.href"
                       class="social-block__item"

                    >
                        <svg v-if="key === 'facebook'" class="social-block__facebook">
                            <use xlink:href="#svg-facebook-2"></use>
                        </svg>
                        <!--                        <svg v-else-if="key === 'instagram'">-->
                        <!--                            <use xlink:href="#svg-instagram"></use>-->
                        <!--                        </svg>-->
                    </a>
                    <!--                    <a href="javascript:void(0)" class="social-block__item">-->
                    <!--                        <svg class="social-block__pinterest">-->
                    <!--                            <use xlink:href="#svg-pinterest"></use>-->
                    <!--                        </svg>-->
                    <!--                    </a>-->
                    <!--                    <a href="javascript:void(0)" class="social-block__item">-->
                    <!--                        <svg>-->
                    <!--                            <use xlink:href="#svg-twitter"></use>-->
                    <!--                        </svg>-->
                    <!--                    </a>-->
                    <!--                    <a href="javascript:void(0)" class="social-block__item">-->
                    <!--                        <svg>-->
                    <!--                            <use xlink:href="#svg-message"></use>-->
                    <!--                        </svg>-->
                    <!--                    </a>-->
                </div>
            </div>
            <div class="product-detail__block">
                <div class="product-detail-article">
                    <p class="product-detail-article__text">{{ messages.article }}. {{product.article}}</p>
                    <DefLabels :result="product.labels" />
                </div>
                <div class="product-detail-name">
                    <h2 class="product-detail-name__type">{{product.type}}</h2>
                    <div class="product-detail-name__title">{{product.name}}</div>
                </div>
                <p class="product-detail__name" v-if="product.previewText" v-html="product.previewText"></p>
                <sku-select v-if="product.propsForCheck && Object.keys(product.propsForCheck).length" :result="product"/>
                <ProductPromotion
                    v-if="screenWidth >= 768 && product.actions"
                    :result="product.actions"
                    :messages="messages"
                />
                <div v-if="product.offer.price.discountPercent" class="product-detail__discount">{{ product.offer.price.printDiscountPercent }}</div>
                <div class="product-detail__price-block">
                    <p v-if="product.printDiscountPercent" class="product-detail__discount">{{product.printDiscountPercent}}</p>
                    <div>
                            <span v-if="product.offer.price.printPrice && product.offer.price.price > 0" class="def-price">
                              {{product.offer.price.printPrice}}
                            </span>
                        <span v-else class="def-price__not-available">{{obData.messages.notAvailableText}}</span>
                        <span v-if="product.offer.price.printPriceOld && +product.offer.price.printPrice !== +product.offer.price.printPriceOld"
                              class="def-price-old">{{product.offer.price.printPriceOld}}</span>
                        <span v-if="product.offer.price.printDiscount" class="product-detail__saving" v-html="product.offer.price.printDiscount"></span>
                        <span v-else class="product-detail__saving" v-html="product.offer.price.discount"></span>
                    </div>
                </div>
                <div class="product-detail__buttons">
                    <div v-if="obData.messages && product.offer.price.price > 0"
                         @click.prevent="addToBasket(product)"
                         class="def-button"
                    >
                        <svg><use xlink:href="#svg-basket"></use></svg>
                        {{obData.messages.buy}}
                    </div>
                    <div v-else class="def-button def-button__not-available">
                        повідомити про наяність
                    </div>
                    <div class="product-detail__like" v-if="authInfo.isAuthorized">
                        <def-like :result="product"/>
                    </div>
                </div>
                <ProductPromotion
                    v-if="screenWidth < 768 && product.actions"
                    :result="product.actions"
                    :messages="messages"
                />
                <!-- Отображать если товар есть в наличии и на складе -->
                <div
                    v-if="isAvailable() && !popupMode && stores && stores.length > 0"
                    class="product-deliveries"
                >
                    <GetToday
                        :result="product"
                        :messages="messages"
                    />
                    <ProductIPost
                        v-if="isIPostAvailable"
                        :product="product"
                        :messages="messages"
                    />
                </div>

                <drop-down v-if="obData.delivery">
                    <template v-slot:header>{{  obData.messages.howGetProduct }}</template>
                    <div>
                        <div class="get-order" v-for="item in obData.delivery">
                            <div class="get-order__col">
                                <h5 class="get-order__header">{{ item.printName }}:</h5>
                                <!--                                    <GetToday v-if="item.code === 'STORE'" :result="product" :messages="obData.messages" ref="getToday" @click="this.$refs.getToday[0].doOpen()">-->
                                <!--                                        <template v-slot:link >-->
                                <!--                                            <span class="get-order__map" >{{ item.description }}</span>-->
                                <!--                                        </template>-->
                                <!--                                    </GetToday>-->
                                <span>{{ item.description }}</span>
                            </div>
                            <div class="get-order__col">
                                <span class="get-order__free">{{ item.price.printPrice }}</span>
                                <span class="get-order__day" >{{item.time.messages.deliveryTime}}</span>
                            </div>
                        </div>
                    </div>
                </drop-down>

                <drop-down  v-if="displayProperties" :active="setOpenTab('displayProperties')">
                    <template v-slot:header>{{ obData.messages && obData.messages.displayProperties }}</template>
                    <div>
                        <div class="product-description" v-for="(item,i) in displayProperties" :key="i" :result="item">
                            <h5 class="product-description__title">{{item.name}} </h5>
                            <div class="product-description__values">
                                  <span v-if="Array.isArray(item.value)" v-for="val in item.value">
                                      {{ val }}
                                  </span>
                                <span v-else>
                                      {{ item.value }}
                                  </span>
                            </div>
                        </div>
                    </div>
                </drop-down>

                <drop-down v-if="product.detailText" :active="setOpenTab('detailText')">
                    <template v-slot:header>{{ obData.messages && obData.messages.detailText }}</template>
                    <div class="choice-text">{{product.detailText}}</div>
                </drop-down>
                <drop-down>
                    <template v-slot:header class="shop__title">{{ obData.messages.availableInStores }}</template>
                    <div class="shop" v-for="store of this.storesFilteredByAmount">
                        <h5 class="shop__name">{{ store.title }}</h5>
                        <span class="shop__address">{{ store.address }}</span>
                    </div>
                </drop-down>
                <div class="quick-view-link" v-if="popupMode">
                    <a v-if="obData.messages" :href="product.detailPage" class="quick-view-link__item">
                        {{ obData.messages.detailPageLink }}
                    </a>
                </div>
            </div>
        </div>

        <preloader ref="preloader" />
        <vue-popup v-model="toggleAddToBasket" :styles="{maxWidth: '790px'} ">
            <addToBasketModal :result="product" :messages="obData.messages" @close="close"/>
        </vue-popup>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from "vuex";

    export default {
        name: 'product-detail',
        selector: '.product-detail',
        props: {
            popupMode: {
                type: Boolean,
                default: false
            },
        },
        data(){
            return {
                toggleAddToBasket: false,
                active: false,
                open: true,
                // htmlText: 'Обработчик доставки "Новая почта" <a href="http://novaposhta.ua" >http://novaposhta.ua</a>. Вес до 100 кг.'
            }
        },
        computed: {
            ...mapState({
                authInfo: ({ personal }) => personal.data?.authInfo,
                product: ({ product }) => product.data?.product,
                messages: ({ product }) => product.data?.messages,
                cities: ({ product }) => product.data?.stores?.cities,
                obData: ({ product }) => product?.data,
                stores: ({ stores }) => stores?.data?.stores,
            }),
            ...mapGetters({
                isAvailable: 'product/isAvailable',
            }),
            storesFilteredByAmount() {
                return this?.stores.filter(el => el.amount > 0);
            },
            sku() {
                for (let offerCode in this.product.offers) {
                    if (this.product.offers[offerCode].current) {
                        return this.product.offers[offerCode];
                    }
                }
                return {
                    id: 0,
                }
            },
            displayProperties() {
                return {...this?.product?.displayProperties, ...this?.product?.offer?.displayProperties};
            },
            isIPostAvailable() {
                return !!this.cities?.find(el => el.UF_IPOST_DELIVERY == 1);
                // return this.cities?.filter(el => el.UF_IPOST_DELIVERY == 1).length > 0;
            },
        },
        methods: {
            ...mapActions({
                basketAdd: 'basket/add',
            }),
            setOpenTab( value ){
                return this.obData.messages.activTabName === value;

                //if ( this.obData.messages.activTabName === value ) {
                 /*   this.active = true;
                    this.open = false;
                } else if (this.obData.messages.activTabName === value ) {
                    this.active = false;
                    this.open = true;
                }*/
            },
            addToBasket(item) {
                this.$emit('close');
                this.$emit('openModalBuy', this.product);
                // console.log(item);
                this.toggleAddToBasket = true;

                // Просто добавление нужного товара в корзину
                if (1) {
                    let id = 0;
                    if (item.offer && item.offer.id) {
                        id = item.offer.id;
                    } else {
                        id = item.id;
                    }
                    this.handlerClickGoogle();
                    this.handlerClickFacebook();
                    this.handlerClickGtag();
                    this.basketAdd({ id });
                }
            },
            handlerClickGoogle() {
                try {
                    const product = this.obData.dataLayer.data.products[this.product.offer.id ?? this.product.id];
                    // console.log(product);
                    dataLayer.push({
                        'ecommerce': {
                            'currencyCode': this.obData.dataLayer.currencyCode,
                            'add': {
                                'products': [{
                                    'name': product.name,
                                    'id': product.id,
                                    'price': product.price,
                                    'brand': 'Love you',
                                    'category': product.category,
                                    'variant': product.variant,
                                    'quantity': 1,
                                }]
                            }
                        },
                        'event': 'gtmUaEvent',
                        'gtmUaEventCategory': 'Enhanced Ecommerce',
                        'gtmUaEventAction': 'Adding a Product to a Shopping Cart',
                        'gtmUaEventNonInteraction': 'False'
                    });
                } catch (err) {
                    console.error(err);
                }
            },
            handlerClickFacebook() {
                try {
                    const product = this.obData.fb.data;
                    fbq('track', 'AddToCart', {
                        content_type: 'product',
                        content_ids: product.content_ids,
                        content_name: product.content_name,
                        content_category: product.content_category,
                        value: product.value,
                        currency: product.currency
                    });
                } catch (err) {
                    console.error(err);
                }
            },
            handlerClickGtag() {
                try {
                    const product = this.obData.gtag.data;
                    gtag('event', 'add_to_cart', {
                        'send_to': 'AW-440849847',
                        'value': product.value,
                        'items': product.items

                    });
                } catch (err) {
                    console.error(err);
                }
            },
            /** change sku data **/
            // changeData(res) {
            //     let oldOffers = this.product.offers;
            //
            //
            //     this.product.propsForCheck = res.product.propsForCheck;
            //     this.product.offers = res.product.offers;
            //     this.product.offer = res.product.offer;
            //     this.product.price = this.sku.price;
            //     let tmpOffer = {};
            //     for (let offerCode in this.product.offers) {
            //         this.product.offers[offerCode].delivery = oldOffers[offerCode].delivery;
            //         if (this.product.offers[offerCode].current) {
            //             tmpOffer = oldOffers[offerCode];
            //         }
            //     }
            //     if(tmpOffer.delivery!=undefined) {
            //         this.obData.delivery = tmpOffer.delivery;
            //     }
            //
            //     this.product.detailPage = res.product.detailPage;
            //
            //     // history.replaceState(null, null, res.product.detailPage);
            // },
            async getDataForPopup () {
                try {
                    const preloader = this.$refs.preloader;
                    preloader.add();
                    const response = await axios(this.product.detailPageApi);
                    if (response.status === 200) {
                        this.obData = response.data;
                        this.tmp = response.data;
                        preloader.remove();
                    }
                } catch (err) {
                    console.error(err);
                }
            },
            close() {
                this.toggleAddToBasket = false;
                this.$emit('close');
            }
        },
        mounted() {
            if (this.obData && this.product && this.product.detailPageApi) {
                this.getDataForPopup();
            }


            if (App.debug) {
                console.log('Component: product-detail', this.product)
            }
            // console.log(this.isAvailable(), 123123);
        }
    }
</script>

<style lang="scss" scoped>
.product-detail{
    position: relative;
    &__page{
        margin-bottom: 60px;
    }
    &__left{
        width: 58.3333333333%;
    }
    &__right{
        width: 41.6666666667%;
    }
    &__block{
        //@include point-lg{
        //    max-width: 401px;
        //}
    }
    &__title{
        font-weight: 500;
        font-size: rem(20);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-colour-primary);
        margin-bottom: 4px;
        @include point-md{
            font-size: rem(24);
            margin-bottom: 8px;
        }
        @include point-lg{
            font-size: rem(32);
            margin-bottom: 4px;
        }
    }
    &__name{
        font-size: rem(16);
        color: var(--hyperlink-colour-secondary);
        margin-bottom: 24px;
        @include point-md{
            margin-bottom: 32px;
        }
        @include point-lg{
            font-size: rem(18);
            margin-bottom: 24px;
        }
    }
    &__saving{
        font-size: rem(12);
        line-height: 100%;
        color: #618EAF;
        @include point-md{
            font-size: rem(14);
        }
    }
    &__discount{
        margin-bottom: 2px;
        font-weight: 500;
        font-size: rem(10);
        line-height: 115%;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #C80024;
        @include point-md{
            font-size: rem(12);
        }
    }
    &__price-block{
        margin-bottom: 24px;
    }
    &__buttons{
        display: flex;
        margin-bottom: 27px;
        @include point-md{
            margin-bottom: 40px;
        }
        @include point-lg{
            margin-bottom: 48px;
        }
    }
    &__like{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border: 1px solid #DFDFDF;
        .def-like{
            svg{
                width: 24px;
                height: 24px;
            }
        }
    }
    .def-price{
        font-size: rem(18);
        margin-right: 16px;
        @include point-lg{
            font-size: rem(24);
        }
        &__not-available{
            display: inline-block;
            font-weight: 500;
            font-size: rem(18);
            color: #757575;
            height: 24px;
        }
    }
    .def-price-old{
        font-size: rem(14);
        margin-right: 16px;
        @include point-md{
            font-size: rem(18);
        }
    }

    .def-button{
        display: flex;
        height: 56px;
        font-size: rem(16);
        flex-grow: 1;
        margin-right: 8px;
        @include point-md{
            font-size: rem(18);
        }
        svg{
            fill: #fff;
            width: 24px;
            height: 24px;
            margin-right: 9px;
        }
        &__not-available{
            background-color: #B8D9EC;
        }
    }
    &__shops{
        border-bottom: 1px solid #DFDFDF;
    }
    &__discount{
        font-size: rem(14);
        color: #D80D44;
    }
}
.product-detail-top{
    display: grid;
    grid-template-columns: minmax(0 , 1fr);
    grid-row-gap: 32px;
    @include point-md{
        grid-template-columns: minmax(0, 352px) minmax(0 , 1fr);
        grid-column-gap: 24px;
    }
    @include point-lg{
        grid-template-columns: minmax(0, 712px) 401px;
        grid-column-gap: 103px;
    }
}
.get-order{
    display: flex;
    justify-content: space-between;
    font-size: rem(14);
    color: #757575;
    @include point-md{
        font-size: rem(16);
    }
    &:not(:last-child) {
        margin-bottom: 16px;
    }
    &__col:last-child {
        text-align: right;
    }
    &__header{
        font-weight: 500;
        font-size: rem(16);
        color: var(--text-colour-primary);
        margin-bottom: 5px;
        @include point-md{
            font-size: rem(18);
        }
    }
    &__free{
        display: block;
        font-size: rem(16);
        color: var(--text-colour-secondary);
        margin-bottom: 5px;
        @include point-md{
            font-size: rem(18);
        }
    }
    &__day{
        font-weight: 500;
    }
    &__map{
        text-decoration: underline;
        text-underline-position: under;
        text-decoration-style: dashed;
    }
}
.product-description{
    display: flex;
    justify-content: space-between;
    font-size: rem(16);
    text-align: right;
    color: #757575;
    @include point-md{
        font-size: rem(18);
    }
    &:not(:last-child) {
        margin-bottom: 16px;
    }
    &__title{
        font-weight: 500;
        color: var(--text-colour-primary);
    }
    &__values{
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 2px;
    }
}
.choice-text{
    color: #757575;
    line-height: 120%;
    font-size: rem(16);
    @include point-md{
        font-size: rem(18);
    }
}
.social-block{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    @include point-md{
        margin-top: 20px;
    }
    @include point-lg{
        margin-top: 24px;
    }
    &__item{
        &:not(:last-child) {
            margin-right: 24px;
        }
        svg{
            width: 24px;
            height: 24px;
            fill: var(--border-colour-primary);
        }
    }
}
.quick-view-link{
    margin: 24px 0 32px;
    &__item{
        font-weight: 500;
        font-size: rem(12);
        letter-spacing: 0.1em;
        text-decoration-line: underline;
        text-transform: uppercase;
        color: var(--text-colour-secondary);
        &:hover{
            color: var(--text-colour-secondary);
        }
    }
}
.shop{
    font-weight: 500;
    letter-spacing: 0.08em;
    margin-bottom: 16px;
    &__title{
        text-transform: uppercase;
        color: #191918;

    }
    &__name{
        font-size: rem(18);
        color: var(--text-colour-primary);
        margin-bottom: 5px;
    }
    &__address{
        color: #757575;
    }
}
.product-deliveries{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}
.product-detail-article{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    &__text{
        font-size: rem(12);
        color: #757575;
        margin-right: 8px;
        @include point-md{
            font-size: rem(14);
        }
    }
}
.product-detail-name{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 24px;

    @include point-md{
        margin-bottom: 32px;
    }
    @include point-lg{
        margin-bottom: 24px;
    }
    &__type {
        width: 100%;
        font-weight: 500;
        font-size: rem(20);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-colour-primary);
        margin-bottom: 4px;
        @include point-md{
            font-size: rem(24);
            margin-bottom: 8px;
        }
        @include point-lg{
            font-size: rem(32);
            margin-bottom: 4px;
        }
    }

    &__title{
        font-size: rem(16);
        margin-right: 8px;
        @include point-md{
            font-size: rem(18);
        }
    }
}
</style>